var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/category-content-slots.j2"] = require( "macros/category-content-slots.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-inline-content-slot.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/category-content-slots.j2", false, "category/templates/category-inline-content-slot.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("contentSlot", t_1);
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"inlineContentSlots");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("inlineContentSlot", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n    ";
var t_8;
t_8 = (lineno = 6, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_7,"fields.position",0]));
frame.set("position", t_8, true);
if(frame.topLevel) {
context.setVariable("position", t_8);
}
if(frame.topLevel) {
context.addExport("position", t_8);
}
output += "\n    ";
var t_9;
t_9 = (lineno = 7, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_7,"fields.contentOrder"]));
frame.set("contentOrder", t_9, true);
if(frame.topLevel) {
context.setVariable("contentOrder", t_9);
}
if(frame.topLevel) {
context.addExport("contentOrder", t_9);
}
output += "\n\n    <div class=\"\n        o-category-content-slot\n        u-margin-bottom--large\n        ";
if(runtime.memberLookup((runtime.memberLookup((t_7),"fields")),"bannerSize") == "2x1") {
output += "\n            c-product-tile--two-by-one\n        ";
;
}
else {
output += "\n            c-product-tile\n        ";
;
}
output += "\n        js-category__inline-content-slot\n    \" data-qa-inline-content\n    data-qa-inline-content-position=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "position"), env.opts.autoescape);
output += "\"\n    data-qa-content-order=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "contentOrder"), env.opts.autoescape);
output += "\"\n    hidden>\n        ";
output += runtime.suppressValue((lineno = 22, colno = 45, runtime.callWrap(runtime.memberLookup((t_1),"displayInlineContentSlot"), "contentSlot[\"displayInlineContentSlot\"]", context, [t_7])), env.opts.autoescape);
output += "\n    </div>\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-inline-content-slot.j2"] , dependencies)